import React from 'react';
import MuiAppBar from '@material-ui/core/AppBar';
import styled from 'styled-components';
import { withTheme } from '@material-ui/core/styles';
import Header from '../header';
import Footer from '../footer';
import I18n from 'i18n';
const { lookup } = new I18n();

const Content = styled.div`
  // min-height for footer
  min-height: calc(100vh - 50px);
  padding: ${p => p.theme.fixed.headerHeight}px 0;
`;

const AppBar = styled(MuiAppBar)(
  p => `
  box-shadow: none;
  background-color: ${p.theme.colors.brand};
`
);

const Layout = props => {
  return (
    <>
      <AppBar>
        <Header />
      </AppBar>
      <Content>{props.children}</Content>
      <Footer>
        {`${lookup('copyright')} ${new Date().getFullYear()} ${lookup(
          'footer_text'
        )}`}
      </Footer>
    </>
  );
};

export default withTheme(Layout);
